module.exports = __webpack_public_path__ + "img/my_qrcode_lingying.2c1884d.webp";